// @ts-nocheck
import React, { useState, useEffect, useRef, Fragment } from 'react';
import { ASSETS, flagSvg } from './assets';

const PACKS = [
  {
    code: 'EN', name: 'English', flag: '🇺🇸',
    venue: 'Oakridge', sub: 'Zoo',
    primary: '#2E7D4F',
    title: 'ZooQuest Audio Adventure',
    section: 'Exhibits',
    stops: [
      { n: 'Welcome to the Audio Zoo Tour', d: 'Your guide for today: Discover...' },
      { n: '2. The Graceful Giraffes',      d: 'Hear about their long necks a...' },
      { n: '3. The Mighty Elephants',       d: 'Learn about their intelligence...' },
      { n: '4. The Swift Cheetahs',         d: 'Listen to the sounds of the fa...' },
    ],
  },
  {
    code: 'ES', name: 'Español', flag: '🇪🇸',
    venue: 'Oakridge', sub: 'Zoo',
    primary: '#2E7D4F',
    title: 'Aventura de Audio ZooQuest',
    section: 'Exhibiciones',
    stops: [
      { n: 'Bienvenidos al Tour de Audio', d: 'Tu guía de hoy: Descubre...' },
      { n: '2. Las Jirafas Elegantes',     d: 'Escucha sobre sus cuellos...' },
      { n: '3. Los Poderosos Elefantes',   d: 'Aprende sobre su inteligencia...' },
      { n: '4. Los Veloces Guepardos',     d: 'Escucha los sonidos de los...' },
    ],
  },
  {
    code: 'JA', name: '日本語', flag: '🇯🇵',
    venue: 'Oakridge', sub: 'Zoo',
    primary: '#2E7D4F',
    title: 'ズークエスト 音声ツアー',
    section: '展示',
    stops: [
      { n: '音声ツアーへようこそ', d: '今日のガイド：発見しよう...' },
      { n: '2. 優雅なキリン',     d: '長い首について聞こう...' },
      { n: '3. 力強いゾウ',       d: 'その知能について学ぼう...' },
      { n: '4. 俊敏なチーター',   d: 'ネコ科の音を聞こう...' },
    ],
  },
  {
    code: 'AR', name: 'العربية', flag: '🇸🇦', rtl: true,
    venue: 'Oakridge', sub: 'Zoo',
    primary: '#2E7D4F',
    title: 'مغامرة صوتية في حديقة الحيوان',
    section: 'المعارض',
    stops: [
      { n: 'مرحبا بكم في الجولة الصوتية', d: 'دليلك اليوم: اكتشف...' },
      { n: '2. الزرافات الرشيقة',        d: 'استمع إلى رقابها الطويلة...' },
      { n: '3. الفيلة العظيمة',          d: 'تعرف على ذكائها...' },
      { n: '4. الفهود السريعة',          d: 'استمع إلى أصوات...' },
    ],
  },
  {
    code: 'DE', name: 'Deutsch', flag: '🇩🇪',
    venue: 'Oakridge', sub: 'Zoo',
    primary: '#2E7D4F',
    title: 'ZooQuest Audio-Abenteuer',
    section: 'Ausstellungen',
    stops: [
      { n: 'Willkommen bei der Audio-Tour', d: 'Dein Guide für heute...' },
      { n: '2. Die anmutigen Giraffen',     d: 'Hör von ihren langen Hälsen...' },
      { n: '3. Die mächtigen Elefanten',    d: 'Lerne über ihre Intelligenz...' },
      { n: '4. Die flinken Geparden',       d: 'Lausche den Geräuschen...' },
    ],
  },
];

// Back-compat: HeroScene uses LANGS for the orbit pill labels.
// The order MUST match PHONE_LANG_CYCLE so the orbit pill highlight and the
// phone screen content stay in sync. Names are the native words used as the
// label on the orbit pills around the phone.
const LANGS = [
  { code: 'EN', name: 'English' },
  { code: 'ES', name: 'Español' },
  { code: 'FR', name: 'Français' },
  { code: 'DE', name: 'Deutsch' },
  { code: 'UK', name: 'Українська' },
  { code: 'FA', name: 'فارسی' },
  { code: 'AR', name: 'العربية' },
  { code: 'JA', name: '日本語' },
];

// ====== QR Code (procedural) ======
function QRCode({ size = 120, color = "#0B1A3F", bg = "#fff" }) {
  // Procedural pseudo-QR: deterministic grid of squares + 3 corner markers
  const cells = 21;
  const cell = size / cells;
  // simple deterministic noise
  const rng = (x, y) => ((x * 73856093) ^ (y * 19349663)) % 7 < 3;
  const isCorner = (x, y) => (
    (x < 7 && y < 7) || (x > cells - 8 && y < 7) || (x < 7 && y > cells - 8)
  );
  const squares = [];
  for (let y = 0; y < cells; y++) {
    for (let x = 0; x < cells; x++) {
      if (isCorner(x, y)) continue;
      if (rng(x, y)) {
        squares.push(<rect key={`${x}-${y}`} x={x * cell} y={y * cell} width={cell} height={cell} fill={color} />);
      }
    }
  }
  const corner = (cx, cy) => (
    <g key={`c${cx}-${cy}`}>
      <rect x={cx * cell} y={cy * cell} width={7 * cell} height={7 * cell} fill={color} />
      <rect x={(cx + 1) * cell} y={(cy + 1) * cell} width={5 * cell} height={5 * cell} fill={bg} />
      <rect x={(cx + 2) * cell} y={(cy + 2) * cell} width={3 * cell} height={3 * cell} fill={color} />
    </g>
  );
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ display: 'block' }}>
      <rect width={size} height={size} fill={bg} />
      {squares}
      {corner(0, 0)}
      {corner(cells - 7, 0)}
      {corner(0, cells - 7)}
    </svg>
  );
}

// Lang codes used: EN, ES, FR, DE, UK, FA, AR, HI — falls back to EN when a
// language hasn't been fully translated yet.
const PHONE_LANG_CYCLE = ['EN', 'ES', 'FR', 'DE', 'UK', 'FA', 'AR', 'JA'];
function PhoneTour({ langIndex = 0 }) {
  const langCode = PHONE_LANG_CYCLE[langIndex % PHONE_LANG_CYCLE.length];
  const T = tr(langCode);
  const [screen, setScreen] = useState('intro');
  const goTo = (next) => setScreen(next);
  const imgSrc =
    screen === 'intro'    ? ASSETS.phoneIntro :
    screen === 'question' ? ASSETS.phoneQ :
    screen === 'correct'  ? ASSETS.phoneCorrect :
                            ASSETS.phoneWrong;
  return (
    <div className="phone-device" style={{
      width: 270, height: 540, borderRadius: 38,
      background: '#0B1A3F',
      padding: 4,
      boxShadow: '0 30px 70px -25px rgba(11,26,63,.5), inset 0 0 0 2px rgba(255,255,255,.06)',
      position: 'relative',
    }}>
      {/* Click here prompt removed */}
      {/* notch */}
      <div style={{
        position: 'absolute', top: 12, left: '50%', transform: 'translateX(-50%)',
        width: 96, height: 24, background: '#000', borderRadius: 16, zIndex: 10,
      }} />
      <div style={{
        background: '#0B1A3F', borderRadius: 34, height: '100%',
        overflow: 'hidden', position: 'relative',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        {screen === 'correct' ? (
          <CorrectScreen onTap={() => goTo('intro')} T={T}/>
        ) : screen === 'wrong' ? (
          <WrongScreen onTap={() => goTo('question')} T={T}/>
        ) : screen === 'intro' ? (
          <IntroScreen onNext={() => goTo('question')} T={T}/>
        ) : screen === 'question' ? (
          <QuestionScreen
            onWrong={() => goTo('wrong')}
            onCorrect={() => goTo('correct')}
            T={T}
          />
        ) : (
          <img
            src={imgSrc}
            alt="CheQRboard trivia screen"
            style={{
              width: '100%', height: 'auto',
              display: 'block',
              alignSelf: 'flex-start',
              transition: 'opacity .25s ease',
            }}
          />
        )}

        {/* INTRO / QUESTION — handled by their own screens above */}
        {false && screen === 'question' && (
          <Fragment>
            <button type="button" onClick={() => goTo('wrong')} aria-label="Feathers glow"
              style={hotspot(47, 9.5)}/>
            <button type="button" onClick={() => goTo('correct')} aria-label="Hearing and night vision"
              style={hotspot(59, 9.5)}/>
            <button type="button" onClick={() => goTo('wrong')} aria-label="Bouncing sounds"
              style={hotspot(71, 9.5)}/>
            <button type="button" onClick={() => goTo('wrong')} aria-label="Eyes adjust"
              style={hotspot(83, 9.5)}/>
          </Fragment>
        )}


        {/* WRONG — handled by WrongScreen above */}

        {/* CORRECT — handled by CorrectScreen above */}
      </div>
    </div>
  );
}


// Question screen built from HTML elements
function QuestionScreen({ onWrong, onCorrect, T }) {
  const answers = [
    { label: T.answers[0], onClick: onWrong },
    { label: T.answers[1], onClick: onCorrect },
    { label: T.answers[2], onClick: onWrong },
    { label: T.answers[3], onClick: onWrong },
  ];
  return (
    <div className="intro-screen" dir={T.dir}>
      <div className="intro-photo">
        <img src={ASSETS.owlNight} alt="Screech owl"/>
        <div className="intro-flag"><img src={T.flagIcon} alt="" /></div>
        <div className="intro-venue-badge">
          <img src={ASSETS.venueBadge} alt="Venue"/>
        </div>
        <div className="intro-progress"/>
      </div>
      <div className="intro-content">
        <div className="question-title">
          {T.questionTitle.split('\n').map((line, i, arr) => (
            <Fragment key={i}>{line}{i < arr.length - 1 && <br/>}</Fragment>
          ))}
        </div>
        <div className="answer-list">
          {answers.map((a, i) => (
            <button key={i} type="button" className="answer-pill" onClick={a.onClick}>
              <span className="answer-radio"/>
              <span className="answer-text">{a.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ====== Translations for the phone trivia screens ======
// Keyed by language code. Each entry holds every string that appears on the
// intro, question, correct, and wrong screens for that language.
const TRANSLATIONS = {
  EN: {
    flagIcon: flagSvg('us'),
    dir: 'ltr',
    didYouKnow: 'Did You Know?',
    facts: [
      'Owls can turn their heads up to 270 degrees.',
      "Since their eyes are fixed in place and can't move like ours, they have to rotate their heads to look around!",
      'Owls are also famous for being nearly silent flyers. Special soft feathers help muffle the sound of their wings, allowing them to sneak up on prey without making a sound!',
    ],
    nextForTrivia: 'Next for Trivia',
    clickHere: 'Click here',
    questionTitle: 'Why are owls able to hunt\nso well at night?',
    answers: [
      'Their feathers glow softly in the dark',
      'They have excellent hearing and night vision',
      'They use bouncing sounds to find prey',
      'Their eyes adjust quickly in daylight',
    ],
    correctLabel: 'Correct',
    correctInfo: 'Owls use both their amazing eyesight and powerful hearing together to locate prey in the dark!',
    wrongLabel: 'Nope, nice try!',
    tryAgain: 'Try Again',
  },
  ES: {
    flagIcon: flagSvg('es'),
    dir: 'ltr',
    didYouKnow: '¿Sabías que?',
    facts: [
      'Los búhos pueden girar la cabeza hasta 270 grados.',
      'Como sus ojos están fijos y no pueden moverse como los nuestros, tienen que girar la cabeza para mirar a su alrededor.',
      'Los búhos también son famosos por volar casi en silencio. Sus plumas especiales y suaves ayudan a amortiguar el sonido de sus alas, lo que les permite acercarse sigilosamente a sus presas sin hacer ruido.',
    ],
    nextForTrivia: 'Siguiente para trivia',
    clickHere: 'Haz clic aquí',
    questionTitle: '¿Por qué los búhos pueden\ncazar tan bien de noche?',
    answers: [
      'Sus plumas brillan suavemente en la oscuridad',
      'Tienen una audición excelente y visión nocturna',
      'Usan sonidos que rebotan para encontrar presas',
      'Sus ojos se adaptan rápidamente a la luz del día',
    ],
    correctLabel: 'Correcto',
    correctInfo: 'Los búhos usan tanto su increíble vista como su potente audición para localizar presas en la oscuridad.',
    wrongLabel: 'No, ¡buen intento!',
    tryAgain: 'Inténtalo de nuevo',
  },
  UK: {
    flagIcon: flagSvg('ua'),
    dir: 'ltr',
    didYouKnow: 'Чи знали ви?',
    facts: [
      'Сови можуть повертати голову до 270 градусів.',
      'Оскільки їхні очі зафіксовані на місці й не можуть рухатися, як наші, їм потрібно повертати голову, щоб оглядатися навколо!',
      'Сови також відомі своїм майже безшумним польотом. Особливе м’яке пір’я допомагає приглушити звук їхніх крил, дозволяючи їм непомітно підкрадатися до здобичі!',
    ],
    nextForTrivia: 'Далі до вікторини',
    clickHere: 'Натисніть тут',
    questionTitle: 'Чому сови так добре\nполюють уночі?',
    answers: [
      'Їхнє пір’я м’яко світиться в темряві',
      'Вони мають чудовий слух і нічний зір',
      'Вони використовують відлуння звуків, щоб знаходити здобич',
      'Їхні очі швидко пристосовуються до денного світла',
    ],
    correctLabel: 'Правильно',
    correctInfo: 'Сови використовують свій неймовірний зір і потужний слух разом, щоб знаходити здобич у темряві!',
    wrongLabel: 'Ні, гарна спроба!',
    tryAgain: 'Спробуйте ще раз',
  },
  JA: {
    flagIcon: flagSvg('jp'),
    dir: 'ltr',
    didYouKnow: '知っていましたか？',
    facts: [
      'フクロウは頭を最大270度まで回すことができます。',
      '目が固定されていて、私たちのように動かすことができないため、周りを見るには頭を回す必要があります。',
      'フクロウは、ほとんど音を立てずに飛ぶことでも有名です。特別な柔らかい羽が翼の音を抑え、音を立てずに獲物に近づくことができます。',
    ],
    nextForTrivia: 'クイズへ',
    clickHere: 'ここをクリック',
    questionTitle: 'なぜフクロウは夜でも\n上手にかりができるのでしょうか?',
    answers: [
      '羽が暗闇でやわらかく光る',
      '優れた聴覚と夜間視力を持っている',
      '反響音を使って獲物みつける。',
      '目が昼間の光にすぐ順応する。',
    ],
    correctLabel: '正解',
    correctInfo: 'フクロウは、すばらしい視力と強力な聴覚を組み合わせて、暗闇の中で獲物を見つけます！',
    wrongLabel: '惜しいです。',
    tryAgain: 'もう一度試してみてください',
  },
  FR: {
    flagIcon: flagSvg('fr'),
    dir: 'ltr',
    didYouKnow: 'Le saviez-vous ?',
    facts: [
      'Les hiboux peuvent tourner leur tête jusqu’à 270 degrés.',
      'Comme leurs yeux sont fixes et ne peuvent pas bouger comme les nôtres, ils doivent tourner la tête pour regarder autour d’eux !',
      'Les hiboux sont aussi connus pour leurs vols presque silencieux. Leurs plumes spéciales et douces aident à étouffer le bruit de leurs ailes, ce qui leur permet de s’approcher de leurs proies sans faire de bruit.',
    ],
    nextForTrivia: 'Quiz suivant',
    clickHere: 'Cliquez ici',
    questionTitle: 'Pourquoi les hiboux sont-ils\nsi doués pour chasser la nuit ?',
    answers: [
      'Leurs plumes brillent doucement dans l’obscurité',
      'Ils ont une excellente ouïe et une très bonne vision nocturne',
      'Ils utilisent des sons qui rebondissent pour trouver leurs proies',
      'Leurs yeux s’adaptent rapidement à la lumière du jour',
    ],
    correctLabel: 'Correct',
    correctInfo: 'Les hiboux utilisent à la fois leur excellente vision et leur ouïe puissante pour repérer leurs proies dans l’obscurité !',
    wrongLabel: 'Non, bien essayé !',
    tryAgain: 'Réessayez',
  },
  AR: {
    flagIcon: flagSvg('sa'),
    dir: 'rtl',
    didYouKnow: 'هل تعلم؟',
    facts: [
      'يمكن للبوم أن يدير رأسه حتى ۲۷۰ درجة.',
      'بما أن عيونه ثابتة في مكانها ولا تتحرك مثل عيوننا، عليه أن يدير رأسه لينظر حوله.',
      'كما يُعرف البوم بقدرته على الطيران بصمت شبه تام. تساعده ريشاته الناعمة الخاصة على تخفيف صوت جناحيه، مما يسمح له بالاقتراب من فريسته دون إصدار أي صوت.',
    ],
    nextForTrivia: 'التالي للأسئلة',
    clickHere: 'انقر هنا',
    questionTitle: 'لماذا يستطيع البوم\nالصيد ببراعة في الليل؟',
    answers: [
      'ريشه يتوهج برفق في الظلام',
      'لديه سمع ممتاز ورؤية ليلية قوية',
      'يستخدم الأصوات المرتدة للعثور على الفريسة',
      'تتكيف عيناه بسرعة مع ضوء النهار',
    ],
    correctLabel: 'صحيح',
    correctInfo: 'يستخدم البوم بصره المذهل وسمعه القوي معًا لتحديد مكان الفريسة في الظلام!',
    wrongLabel: 'لا، محاولة جيدة!',
    tryAgain: 'حاول مرة أخرى',
  },
  DE: {
    flagIcon: flagSvg('de'),
    dir: 'ltr',
    didYouKnow: 'Wusstest du schon?',
    facts: [
      'Eulen können ihren Kopf um bis zu 270 Grad drehen.',
      'Da ihre Augen fest an ihrem Platz sitzen und sich nicht wie unsere bewegen können, müssen sie ihren Kopf drehen, um sich umzuschauen.',
      'Eulen sind auch dafür bekannt, fast lautlos zu fliegen. Spezielle weiche Federn helfen dabei, das Geräusch ihrer Flügel zu dämpfen, sodass sie sich ihrer Beute lautlos nähern können.',
    ],
    nextForTrivia: 'Weiter zum Quiz',
    clickHere: 'Hier klicken',
    questionTitle: 'Warum können Eulen\nnachts so gut jagen?',
    answers: [
      'Ihre Federn leuchten sanft im Dunkeln',
      'Sie haben ein ausgezeichnetes Gehör und eine sehr gute Nachtsicht',
      'Sie nutzen zurückgeworfene Geräusche, um Beute zu finden',
      'Ihre Augen passen sich schnell an Tageslicht an',
    ],
    correctLabel: 'Richtig',
    correctInfo: 'Eulen nutzen ihre erstaunliche Sehkraft und ihr starkes Gehör zusammen, um Beute im Dunkeln zu finden.',
    wrongLabel: 'Nein, guter Versuch!',
    tryAgain: 'Versuche es noch einmal',
  },
  FA: {
    flagIcon: flagSvg('ir'),
    dir: 'rtl',
    didYouKnow: 'آیا می‌دانستید؟',
    facts: [
      'جغدها می‌توانند سر خود را تا ۲۷۰ درجه بچرخانند.',
      'از آنجا که چشم‌های آنها در جای خود ثابت است و مانند چشم‌های ما حرکت نمی‌کند، برای نگاه کردن به اطراف باید سرشان را بچرخانند!',
      'جغدها همچنین به پرواز تقریباً بی‌صدا معروف هستند. پرهای نرم و ویژه آن‌ها کمک می‌کند صدای بال ‌زدنشان کمتر شود و بتوانند بدون ایجاد صدا، به شکار خود نزدیک شوند!',
    ],
    nextForTrivia: 'بعدی برای آزمون',
    clickHere: 'اینجا کلیک کنید',
    questionTitle: 'چرا جغدها می‌توانند شبها\nاین ‌قدر خوب شکار کنند؟',
    answers: [
      'پرهای آنها در تاریکی به نرمی می ‌درخشد',
      'آنها شنوایی عالی و دید در شب بسیار خوبی دارند',
      'آنها از صداهای بازتابی برای پیدا کردن شکار استفاده می‌کنند',
      'چشم‌ های آنها در نور روز به‌ سرعت تطبیق میابد',
    ],
    correctLabel: 'درست است',
    correctInfo: 'جغدها از بینایی شگفت‌ انگیز و شنوایی قدرتمند خود با هم استفاده می‌کنند تا شکار را در تاریکی پیدا کنند!',
    wrongLabel: 'نه، تلاش خوبی بود!',
    tryAgain: 'دوباره امتحان کنید',
  },
};
// Fallback helper — returns EN copy when a language isn't filled in yet.
function tr(code) {
  return TRANSLATIONS[code] || TRANSLATIONS.EN;
}
function IntroScreen({ onNext, T }) {
  return (
    <div className="intro-screen" dir={T.dir}>
      <div className="intro-photo">
        <img src={ASSETS.owlDay} alt="Barred owl"/>
        <div className="intro-flag"><img src={T.flagIcon} alt="" /></div>
        <div className="intro-venue-badge">
          <img src={ASSETS.venueBadge} alt="Venue"/>
        </div>
        <div className="intro-progress"/>
      </div>
      <div className="intro-content">
        <div className="intro-heading">
          <span className="intro-emoji">🦉</span>
          {T.didYouKnow}
        </div>
        {T.facts.map((fact, i) => <p key={i}>{fact}</p>)}
        <button type="button" className="intro-next" onClick={onNext}>{T.nextForTrivia}</button>
      </div>
    </div>
  );
}

// Animated correct screen — clean overlay elements stage in
function CorrectScreen({ onTap, T }) {
  return (
    <Fragment>
      <div className="result-screen correct" dir={T.dir}>
        <div className="rs-owl"/>
        <div className="rs-badge"/>
        <div className="rs-question">
          {T.questionTitle.split('\n').map((line, i, arr) => (
            <Fragment key={i}>{line}{i < arr.length - 1 && <br/>}</Fragment>
          ))}
        </div>
        <div className="rs-verdict">{T.correctLabel}</div>
        <div className="rs-info">{T.correctInfo}</div>
      </div>
      <button type="button" onClick={onTap} aria-label="Restart"
        style={{ position: 'absolute', inset: 0, background: 'transparent', border: 'none', cursor: 'pointer', zIndex: 10 }}/>
    </Fragment>
  );
}

// Animated wrong screen — clean overlay elements + Try Again button
function WrongScreen({ onTap, T }) {
  return (
    <div className="result-screen wrong" dir={T.dir}>
      <div className="rs-owl"/>
      <div className="rs-badge"/>
      <div className="rs-question">
        {T.questionTitle.split('\n').map((line, i, arr) => (
          <Fragment key={i}>{line}{i < arr.length - 1 && <br/>}</Fragment>
        ))}
      </div>
      <div className="rs-verdict">{T.wrongLabel}</div>
      <button
        type="button"
        onClick={onTap}
        aria-label={T.tryAgain}
        className="rs-tryagain"
      >
        {T.tryAgain}
      </button>
    </div>
  );
}
// `topPct` is the top position of the row in % of the phone container.
function hotspot(topPct, heightPct = 6.5) {
  return {
    position: 'absolute',
    left: '4%', right: '4%',
    top: `${topPct}%`,
    height: `${heightPct}%`,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    borderRadius: 999,
  };
}

// ====== Survey mock ======
function SurveyMock() {
  return (
    <div className="mock-window" style={{ width: '100%' }}>
      <div className="mock-titlebar">
        <div className="dots"><span/><span/><span/></div>
        <div className="url">survey.cheqrboard.com/post-visit</div>
      </div>
      <div style={{ padding: 22 }}>
        <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: '#00b4d8', letterSpacing: '.1em', fontWeight: 700 }}>
          QUESTION 2 / 5
        </div>
        <div style={{
          fontFamily: 'var(--font-display)', fontWeight: 700,
          fontSize: 18, color: '#0B1A3F', margin: '6px 0 16px', letterSpacing: '-0.01em', lineHeight: 1.2,
        }}>
          How did the audio tour change your visit?
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[
            { label: 'Loved it — I learned new things', sel: true },
            { label: 'Helpful, but could go deeper', sel: false },
            { label: 'Didn\'t use it', sel: false },
          ].map((o, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 12,
              padding: '12px 14px', borderRadius: 12,
              background: o.sel ? '#0B1A3F' : '#f6f4ec',
              color: o.sel ? '#fff' : '#0B1A3F',
              border: o.sel ? '1px solid #0B1A3F' : '1px solid #e8e4d6',
              fontSize: 13, fontWeight: 600,
            }}>
              <div style={{
                width: 16, height: 16, borderRadius: 999,
                border: '2px solid ' + (o.sel ? '#1FD5F4' : '#cbc6b4'),
                background: o.sel ? '#1FD5F4' : 'transparent',
              }}/>
              {o.label}
            </div>
          ))}
        </div>
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: 11, color: '#6c7596' }}>Auto-translated · 130 languages</div>
          <div style={{
            padding: '8px 14px', borderRadius: 999, background: '#1FD5F4',
            color: '#0B1A3F', fontWeight: 700, fontSize: 12,
          }}>Continue →</div>
        </div>
      </div>
    </div>
  );
}

// ====== Donation mock — matches the real Stripe-hosted CheQRboard flow ======
function DonationMock() {
  return (
    <div className="mock-window" style={{ width: '100%' }}>
      <div className="mock-titlebar">
        <div className="dots"><span/><span/><span/></div>
        <div className="url">donate.stripe.com</div>
      </div>
      <div style={{ padding: 18, background: '#fff' }}>
        {/* Stripe header row: merchant pill */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          marginBottom: 16, paddingBottom: 8,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{
              width: 22, height: 22, borderRadius: 999,
              background: '#f3f4f6', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              border: '1px solid #e5e7eb',
            }}>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              </svg>
            </div>
            <span style={{ fontWeight: 600, fontSize: 12, color: '#0a0a0a' }}>CheQRboard</span>
          </div>
          <div style={{
            fontSize: 10, color: '#6b7280', fontWeight: 600,
            textDecoration: 'underline',
          }}>Details ▾</div>
        </div>

        {/* venue logo (Cornish Seal Sanctuary / SEA LIFE-style) */}
        <div style={{ textAlign: 'center', margin: '10px 0 14px' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: 2,
            fontFamily: 'var(--font-display)', fontWeight: 800,
            fontSize: 18, color: '#0046be', letterSpacing: '.02em',
          }}>
            SEA<span style={{ color: '#f5a623', fontSize: 16, margin: '0 1px' }}>★</span>LIFE
          </div>
        </div>

        {/* title */}
        <div style={{
          textAlign: 'center', fontSize: 13, color: '#0a0a0a',
          marginBottom: 10, fontWeight: 500,
        }}>
          Cornish Seal Sanctuary
        </div>

        {/* amount input */}
        <div style={{
          border: '1px solid #e5e7eb', borderRadius: 8,
          padding: '14px 14px', textAlign: 'center',
          fontSize: 22, fontWeight: 600, color: '#9ca3af',
          marginBottom: 12, fontFamily: 'var(--font-display)',
        }}>
          £0.00
        </div>

        {/* description */}
        <div style={{
          fontSize: 11, color: '#4b5563', lineHeight: 1.5,
          display: 'flex', alignItems: 'flex-start', gap: 6, marginBottom: 14,
        }}>
          <span style={{ flex: 1 }}>
            Our Cornish Seal Sanctuary is dedicated to the rescue and rehabilitation of seal pups in need of...
          </span>
          <span style={{ color: '#6b7280', fontSize: 10 }}>▾</span>
        </div>

        {/* Apple Pay button */}
        <div style={{
          background: '#0a0a0a', color: '#fff',
          padding: '12px', borderRadius: 8,
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
          marginBottom: 12,
        }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="#fff">
            <path d="M17.05 11.97c.04-3.39 2.77-5.02 2.89-5.1-1.58-2.31-4.04-2.63-4.91-2.66-2.09-.21-4.08 1.23-5.14 1.23-1.08 0-2.7-1.21-4.44-1.18-2.28.03-4.4 1.33-5.57 3.37-2.38 4.12-.61 10.21 1.7 13.56 1.13 1.64 2.47 3.48 4.21 3.42 1.7-.07 2.34-1.1 4.39-1.1 2.04 0 2.62 1.1 4.41 1.06 1.82-.03 2.97-1.66 4.07-3.32 1.29-1.9 1.81-3.76 1.84-3.86-.04-.02-3.52-1.35-3.55-5.36zM13.55 2.66c.93-1.13 1.55-2.69 1.38-4.26-1.34.06-2.97.91-3.93 2.02-.86.99-1.62 2.58-1.42 4.11 1.5.12 3.04-.76 3.97-1.87z"/>
          </svg>
          <span style={{ fontWeight: 600, fontSize: 14 }}>Pay</span>
        </div>

        {/* OR divider */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10,
          margin: '12px 0',
        }}>
          <div style={{ flex: 1, height: 1, background: '#e5e7eb' }}/>
          <span style={{ fontSize: 10, color: '#9ca3af', fontWeight: 500 }}>OR</span>
          <div style={{ flex: 1, height: 1, background: '#e5e7eb' }}/>
        </div>

        {/* email field */}
        <div>
          <div style={{ fontSize: 10, color: '#4b5563', marginBottom: 4, fontWeight: 500 }}>Email</div>
          <div style={{
            border: '1px solid #e5e7eb', borderRadius: 8,
            padding: '8px 10px', fontSize: 11, color: '#9ca3af',
          }}>
            email@example.com
          </div>
        </div>

        {/* payment method label */}
        <div style={{
          marginTop: 12, fontSize: 11, fontWeight: 600, color: '#0a0a0a',
        }}>
          Payment method
        </div>
        <div style={{
          marginTop: 6, border: '1px solid #0a0a0a', borderRadius: 8,
          padding: '10px 12px', display: 'flex', alignItems: 'center', gap: 8,
        }}>
          <div style={{
            width: 14, height: 14, borderRadius: 999,
            background: '#0a0a0a',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <div style={{ width: 5, height: 5, borderRadius: 999, background: '#fff' }}/>
          </div>
          <svg width="16" height="12" viewBox="0 0 24 18" fill="none" stroke="#0a0a0a" strokeWidth="2">
            <rect x="1" y="1" width="22" height="16" rx="2"/>
            <line x1="1" y1="6" x2="23" y2="6"/>
          </svg>
          <span style={{ fontSize: 11, color: '#0a0a0a', fontWeight: 500 }}>Card</span>
        </div>
      </div>
    </div>
  );
}

// ====== Analytics dashboard mock (laptop-framed) ======
function AnalyticsMock() {
  return (
    <div className="editor-mock laptop-frame">
      <div className="laptop-bezel">
        <div className="mock-window" style={{ borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
          <img src={ASSETS.analyticsLaptop} alt="CheQRboard analytics dashboard"
               style={{ width: '100%', height: 'auto', display: 'block' }}/>
        </div>
      </div>
      <div className="laptop-base"></div>
    </div>
  );
}

// ====== Trivia / Game mock (turtle example) ======
function TriviaMock() {
  return (
    <div className="mock-window" style={{ width: '100%', background: '#0B1A3F' }}>
      <div className="mock-titlebar" style={{ background: '#142a5c', borderColor: '#1e3a78', color: '#94a0c0' }}>
        <div className="dots"><span/><span/><span/></div>
        <div className="url" style={{ color: '#94a0c0' }}>play.cheqrboard.com/turtle-trail</div>
      </div>
      <div style={{ padding: 22, color: '#fff' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <div style={{
            fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '.12em',
            color: '#1FD5F4', fontWeight: 700,
          }}>🐢 MEET TURT · Q 3 / 8</div>
          <div style={{ display: 'flex', gap: 4 }}>
            {[1,1,1,0,0,0,0,0].map((on, i) => (
              <div key={i} style={{
                width: 16, height: 4, borderRadius: 2,
                background: on ? '#1FD5F4' : 'rgba(255,255,255,.15)',
              }}/>
            ))}
          </div>
        </div>
        <div style={{
          fontFamily: 'var(--font-display)', fontWeight: 700,
          fontSize: 19, lineHeight: 1.2, letterSpacing: '-0.015em',
          marginBottom: 16,
        }}>
          How long can a sea turtle hold its breath underwater?
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {[
            { label: '15 minutes', sel: false },
            { label: '2 hours', sel: false },
            { label: '7 hours', sel: true, ok: true },
            { label: '24 hours', sel: false },
          ].map((o, i) => (
            <div key={i} style={{
              padding: '14px 12px', borderRadius: 12,
              background: o.sel ? '#1FD5F4' : 'rgba(255,255,255,.06)',
              color: o.sel ? '#0B1A3F' : '#fff',
              border: '1px solid ' + (o.sel ? '#1FD5F4' : 'rgba(255,255,255,.1)'),
              fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <div style={{
                width: 18, height: 18, borderRadius: 6, fontSize: 10,
                background: o.sel ? '#0B1A3F' : 'rgba(255,255,255,.1)',
                color: o.sel ? '#1FD5F4' : '#94a0c0',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700,
              }}>{['A','B','C','D'][i]}</div>
              {o.label}
              {o.ok && <span style={{ marginLeft: 'auto', fontSize: 12 }}>✓</span>}
            </div>
          ))}
        </div>
        <div style={{ marginTop: 14, fontSize: 11, color: '#94a0c0', display: 'flex', justifyContent: 'space-between' }}>
          <span>+180 pts · Streak ×3</span>
          <span style={{ color: '#1FD5F4' }}>Leaderboard ↗</span>
        </div>
      </div>
    </div>
  );
}

// ====== Ticketing mock ======
function TicketingMock() {
  return (
    <div className="mock-window" style={{ width: '100%' }}>
      <div className="mock-titlebar">
        <div className="dots"><span/><span/><span/></div>
        <div className="url">tickets.cheqrboard.com/night-at-the-museum</div>
      </div>
      <div style={{ padding: 22 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 10, color: '#00b4d8', letterSpacing: '.1em', fontWeight: 700 }}>
              SAT · OCT 12 · 7:00 PM
            </div>
            <div style={{
              fontFamily: 'var(--font-display)', fontWeight: 700,
              fontSize: 18, color: '#0B1A3F', margin: '4px 0 0', letterSpacing: '-0.015em',
            }}>
              Night at the Museum
            </div>
          </div>
          <div style={{
            padding: '4px 10px', borderRadius: 999,
            background: '#d6f6fd', color: '#00b4d8',
            fontFamily: 'var(--font-mono)', fontSize: 10, fontWeight: 700,
          }}>NEW</div>
        </div>
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[
            { tier: 'General', price: '$18', avail: 'available', sel: false },
            { tier: 'Member', price: '$10', avail: 'auto-discount', sel: true },
            { tier: 'Family pack (4)', price: '$60', avail: '12 left', sel: false },
          ].map((t, i) => (
            <div key={i} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              padding: '12px 14px', borderRadius: 12,
              background: t.sel ? '#0B1A3F' : '#f6f4ec',
              color: t.sel ? '#fff' : '#0B1A3F',
              border: '1px solid ' + (t.sel ? '#0B1A3F' : '#e8e4d6'),
            }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 700 }}>{t.tier}</div>
                <div style={{ fontSize: 10, opacity: .7, marginTop: 2 }}>{t.avail}</div>
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 18, letterSpacing: '-0.02em' }}>{t.price}</div>
            </div>
          ))}
        </div>
        <div style={{
          marginTop: 14, padding: '12px 14px', borderRadius: 999, background: '#1FD5F4',
          color: '#0B1A3F', fontWeight: 700, fontSize: 13, textAlign: 'center',
        }}>Reserve 2 tickets →</div>
      </div>
    </div>
  );
}

// ====== CheQRboard CMS Content Library mock ======
function EditorMock() {
  const rows = [
    {
      title: 'Sand Tiger Shark',
      tags: [], type: 'linktree',  views: '19',  updated: 'a day ago',
      img: 'radial-gradient(ellipse at 30% 50%, #8fa3b0 0%, #5d7280 50%, #2b3a44 100%)',
    },
    {
      title: 'Orbicular Batfish (Platax orbicularis)',
      tags: [], type: 'linktree', views: '0', updated: 'a day ago',
      img: 'radial-gradient(ellipse at 40% 40%, #d4a04c 0%, #8a5e1f 50%, #3d2710 100%)',
    },
    {
      title: 'Orbicular Batfish (Platax orbicularis)',
      tags: [], type: 'check', views: '12', updated: '6 days ago',
      img: 'radial-gradient(ellipse at 40% 40%, #d4a04c 0%, #8a5e1f 50%, #3d2710 100%)',
    },
    {
      title: 'Mono (Monodactylus argenteus)',
      tags: [], type: 'img', views: '6', updated: '6 days ago',
      img: 'radial-gradient(ellipse at 50% 50%, #c7d4d8 0%, #6a8a98 50%, #2a3d48 100%)',
    },
    {
      title: 'Mono (Monodactylus argenteus)',
      tags: [], type: 'trivia', views: '7', updated: '6 days ago',
      img: 'radial-gradient(ellipse at 50% 50%, #c7d4d8 0%, #6a8a98 50%, #2a3d48 100%)',
    },
  ];

  const SideItem = ({ icon, label, active }) => (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 9,
      padding: '9px 12px', borderRadius: 7,
      background: active ? '#e6efff' : 'transparent',
      color: active ? '#0046be' : '#374151',
      fontSize: 12, fontWeight: active ? 700 : 500,
      cursor: 'default',
    }}>
      <span style={{ width: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: active ? 1 : .65 }}>{icon}</span>
      {label}
    </div>
  );

  const TypeIcon = ({ kind }) => {
    const stroke = '#0B1A3F';
    if (kind === 'linktree') return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="9" y1="6" x2="20" y2="6"/>
        <line x1="9" y1="12" x2="20" y2="12"/>
        <line x1="9" y1="18" x2="20" y2="18"/>
        <rect x="3" y="4" width="3" height="3" rx=".5"/>
        <rect x="3" y="10" width="3" height="3" rx=".5"/>
        <rect x="3" y="16" width="3" height="3" rx=".5"/>
      </svg>
    );
    if (kind === 'img') return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <circle cx="9" cy="9" r="1.5" fill={stroke}/>
        <path d="M21 15l-5-5L5 21"/>
      </svg>
    );
    if (kind === 'trivia') return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/>
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
        <line x1="12" y1="17" x2="12.01" y2="17"/>
      </svg>
    );
    if (kind === 'audio') return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
        <path d="M21 19a2 2 0 0 1-2 2h-1v-7h3v5zM3 19a2 2 0 0 0 2 2h1v-7H3v5z"/>
      </svg>
    );
    // default: check in circle
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9"/>
        <polyline points="8 12 11 15 16 9"/>
      </svg>
    );
  };

  const colorThumbs = [
    'linear-gradient(135deg, #1FD5F4 0%, #0B1A3F 100%)',
    'linear-gradient(135deg, #F4A11F 0%, #C2410C 100%)',
    'linear-gradient(135deg, #7DD87D 0%, #1F8A5B 100%)',
    'linear-gradient(135deg, #C084FC 0%, #6D28D9 100%)',
    'linear-gradient(135deg, #FB7185 0%, #9F1239 100%)',
  ];
  return (
    <div className="editor-mock laptop-frame">
      <div className="laptop-bezel">
        <div className="mock-window" style={{ borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
          <img src={ASSETS.contentLibrary} alt="CheQRboard content library"
               style={{ width: '100%', height: 'auto', display: 'block' }} />
        </div>
      </div>
      <div className="laptop-base"></div>
    </div>
  );
}

// ====== Survey builder mock — "Add Survey Elements" picker ======
function SurveyBuilderMock() {
  const I = {
    text: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 7 4 5 20 5 20 7"/><line x1="12" y1="5" x2="12" y2="19"/><line x1="9" y1="19" x2="15" y2="19"/></svg>,
    email: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 7l9 6 9-6"/></svg>,
    url: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07L11.5 4.5"/><path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07L12.5 19.5"/></svg>,
    phone: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></svg>,
    contact: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>,
    number: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="9" x2="19" y2="9"/><line x1="5" y1="15" x2="19" y2="15"/><line x1="10" y1="4" x2="8" y2="20"/><line x1="16" y1="4" x2="14" y2="20"/></svg>,
    date: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>,
    time: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>,
    dropdown: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><polyline points="8 11 12 14 16 11"/></svg>,
    choice: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="3"/><polyline points="8 12 11 15 16 9"/></svg>,
    file: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 16V4"/><polyline points="7 9 12 4 17 9"/><path d="M5 20h14"/></svg>,
    rating: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 3 14.9 8.9 21.5 9.8 16.7 14.4 17.8 21 12 17.9 6.2 21 7.3 14.4 2.5 9.8 9.1 8.9 12 3"/></svg>,
    opinion: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/><circle cx="9" cy="6" r="2" fill="#fff"/><circle cx="15" cy="12" r="2" fill="#fff"/><circle cx="8" cy="18" r="2" fill="#fff"/></svg>,
    group: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="5" width="16" height="6" rx="1.5"/><rect x="4" y="14" width="16" height="5" rx="1.5"/></svg>,
    redirect: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07L11.5 4.5"/><path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07L12.5 19.5"/></svg>,
  };
  const cols = [
    [
      { head: 'BASIC TEXT', items: [
        { label: 'Text input', icon: I.text },
        { label: 'Email input', icon: I.email },
        { label: 'URL input', icon: I.url },
        { label: 'Telephone input', icon: I.phone },
        { label: 'Contact info', icon: I.contact },
      ]},
    ],
    [
      { head: 'NUMERIC & DATE', items: [
        { label: 'Number', icon: I.number },
        { label: 'Date input', icon: I.date },
        { label: 'Time input', icon: I.time },
      ]},
    ],
    [
      { head: 'SELECTION & CHOICE', items: [
        { label: 'Dropdown', icon: I.dropdown },
        { label: 'Choice input', icon: I.choice },
      ]},
    ],
    [
      { head: 'FILE & MEDIA', items: [
        { label: 'File upload', icon: I.file },
      ]},
      { head: 'FEEDBACK', items: [
        { label: 'Rating input', icon: I.rating },
        { label: 'Opinion scale', icon: I.opinion },
      ]},
      { head: 'LAYOUT', items: [
        { label: 'Question group', icon: I.group },
      ]},
      { head: 'FLOW', items: [
        { label: 'Redirect to URL', icon: I.redirect },
      ]},
    ],
  ];
  return (
    <div className="survey-builder">
      <div className="sb-head">
        <div className="sb-title">Add Survey Elements</div>
        <div className="sb-close">✕</div>
      </div>
      <div className="sb-grid">
        {cols.map((col, ci) => (
          <div className="sb-col" key={ci}>
            {col.map(g => (
              <div className="sb-group" key={g.head}>
                <div className="sb-group-head">{g.head}</div>
                {g.items.map(it => (
                  <div className="sb-item" key={it.label}>
                    <span className="sb-ic">{it.icon}</span>
                    <span>{it.label}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
      <div className="sb-foot">
        <span className="sb-btn-cancel">Cancel</span>
        <span className="sb-btn-add">Add Element</span>
      </div>
    </div>
  );
}
export {
  LANGS,
  QRCode,
  PhoneTour,
  EditorMock,
  AnalyticsMock,
};
